define('model/CountryModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Country model
     *
     * @class CountryModel
     */
    return BaseModel.extend({

        defaults: {
            id: null,
            name: ''
        }

    });

});
